function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { LottieAnimation } from '../LottieAnimation';
import raisedhands from './raisedhands.json';
export const RaisedHands = ({ ...props
}) => /*#__PURE__*/React.createElement(LottieAnimation, _extends({
  icon: raisedhands,
  ariaLabel: "juich-icoon"
}, props));